module.exports = __webpack_public_path__ + "img/categorias.9bd0deef.svg";